var map = {
	"./AntMall/shoplogo.svg": 80865,
	"./Argos/shoplogo.svg": 42888,
	"./ArgosShop/shoplogo.svg": 42388,
	"./EShop/shoplogo.svg": 61621,
	"./FamilyMart/shoplogo.svg": 80190,
	"./FamilyShop/shoplogo.svg": 34638,
	"./GreenMall/shoplogo.svg": 40523,
	"./Hive/shoplogo.svg": 65240,
	"./INT Overstock/shoplogo.svg": 22003,
	"./Iceland/shoplogo.svg": 54316,
	"./Inchoi/shoplogo.svg": 13650,
	"./Just Shop/shoplogo.svg": 10296,
	"./Laz/shoplogo.svg": 52569,
	"./Mbuy/shoplogo.svg": 92311,
	"./MetaShop/shoplogo.svg": 47875,
	"./SM-wholesale shop/shoplogo.svg": 36525,
	"./Shop2u/shoplogo.svg": 9647,
	"./Shopee/shoplogo.svg": 4444,
	"./TikTok-Wholesale/shoplogo.svg": 21017,
	"./Tongda/shoplogo.svg": 79431,
	"./Zalando/shoplogo.svg": 65611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60348;